import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../../actions/clubActions';
import RichDescription from '../../../components/common/RichDescription';
// import withScrolling from 'react-dnd-scrollzone';
// import ClubDetails
import { Link } from 'react-router';
// import HeaderImage from '../components/common/HeaderImage';
// import TextInput from '../../components/common/TextInput';
import ClubRegTable from './ClubRegTable';
// import FontAwesome from 'react-fontawesome';
// import toastr from 'toastr';
import * as perm from '../../../permission';

class RegisterForEvent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.startRegistrationLink = this.startRegistrationLink.bind(this);
  }

  startRegistrationLink() {
    if (perm.hasPermission(this.props.currentUser, ['super_admin', 'event_admin'], this.props.eventDetails, 'write') ||
        this.props.currentUser.clubs.length > 1) {
      return <ClubRegTable eventId={this.props.eventId} />;
    } else if(this.props.currentUser.clubs.length == 1) {
      return (
        <div className="clearfix">
          <Link to={'/arrangement/' + this.props.eventId + '/registrer/klubb/'+ this.props.currentUser.clubs[0].id +'/info'} className="btn btn-primary pull-right">
            Start påmelding
          </Link>
        </div>
      );
    } else {
      return(
        <div className="clearfix text-right">
          <button className="btn btn-primary disabled">
            Ingen klubber å melde på
          </button>
        </div>
      );
    }
  }

  render() {
    // let details = this.state.details;
    return (
      <div className="container registration-form-wrapper">
        <div className="page-header">
          <h1>Påmeldingskjema - {this.props.eventDetails.name}</h1>
        </div>
        {this.props.eventDetails.reg_description &&
          <div className="panel panel-default">
            <div className="panel-body">
              <RichDescription description={this.props.eventDetails.reg_description} />
            </div>
          </div>
        }
        {this.props.children || this.startRegistrationLink()}
      </div>
    );
  }
}

RegisterForEvent.propTypes = {
  actions: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  eventId: PropTypes.string,
  stage: PropTypes.string,
  loadingClubs: PropTypes.bool,
  children: PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.array,
    React.PropTypes.element,
  ]),
};

function mapStateToProps(state, ownProps) {
  return {
    eventId: ownProps.params.eventId,
    stage: ownProps.params.stage,
    currentUser: state.users.currentUser,
    loadingClubs: state.clubs.loadingClubs,
    clubDetails: state.clubs.clubDetails,
    eventDetails: state.events.eventDetails,
    errors: state.clubs.errors,
    clubDetailsUpdated: state.clubs.clubDetailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterForEvent);



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/RegisterForEvent.js
 **/